import type { ComputedRef, InjectionKey } from 'vue';

export type DropdownContext = {
  selectedValue: ComputedRef<string | null>;
  isListbox: ComputedRef<boolean>;
  tabStopValue: ComputedRef<string | null>;
  selectItem: (value: string) => void;
  registerItem: (value: string, label: string) => void;
  unregisterItem: (value: string) => void;
  close: () => void;
};

export const DROPDOWN_CONTEXT_KEY: InjectionKey<DropdownContext> =
  Symbol('dropdown-context');
